import classNames from "classnames";
import React from "react";
import { StyledContainer } from "./styles";

export default function FillingButton({
  disabled, //
  filling,
  spinner = false,
  onClick = () => {},
  children,
  seconds = 5,
  className = "",
}) {
  return (
    <StyledContainer
      seconds={seconds}
      onClick={disabled ? null : onClick}
      className={classNames({ filling: filling, disabled: !filling && disabled }) + " " + className}
    >
      {children}
      {spinner && filling && <span className="spinner"></span>}
    </StyledContainer>
  );
}
